export const AUTH_TOKEN_KEY = 'authToken';
export const DISCLAIMER_FLAG_KEY = 'disclaimer_accepted';
/** JSON array of User ids who dismissed the passkey enrolment prompt on this device. */
export const PASSKEY_PROMPT_DISMISSED_KEY = 'passkey_prompt_dismissed';
/** sessionStorage: set by a password sign-in in this tab; the enrolment prompt consumes it. */
export const PASSKEY_PROMPT_PENDING_KEY = 'passkey_prompt_pending';
